baseApp.directive('notificationsDrawer', ['$sce', function($sce){
    return{
        templateUrl: '/public/directives/notificationsDrawer.html',
        scope:{
            notifications: '='
        },
        controller: function($scope, $timeout, $state){
            $scope.templates = {
                'PLAN_EXPIRATION': 'planExpiration',
                'ASSIGN_NEW_SOCKET': 'assignNewSocket',
                'NEW_SOCKET_DETECTED': 'newSocket',
                'SOCKET_UPGRADE': 'socketUpgrade'/*,
                'SOCKET_UPGRADE_FAILED': 'socketUpgradeFailed'*/
            };

            $timeout(function(){
                $scope.$root.updateScroll('.notifications-drawer .nano');
            }, 0, false);

            $scope.dismissNotification = function(notification, $event) {
                if ($event && $event.stopPropagation) {
                    $event.stopPropagation();
                }

                var targetIds = [];

                if(notification){
                    $scope.removeNotification(notification);
                    targetIds.push(notification.id);
                }
                else {
                    $scope.notifications.forEach(function(noti){
                        if (noti.dismissible) {
                            $scope.removeNotification(noti);
                            targetIds.push(noti.id);
                        }
                    });
                }

                store.save({
                    skipParsePostData: true,
                    path: '/dismissNotifications',
                    data: targetIds.toString(),
                    dataObj: 'ids',
                    success: function(data){
                    }
                });
            };

            $scope.removeNotification = function(notification){
                var $targetEl = $('#notification-' + notification.id);
                var elHeight = $targetEl.height() + 20;

                $targetEl.animate({
                    opacity: 0,
                    marginBottom: '-' + elHeight,
                }, 600, function () {
                    $timeout(function () {
                        $scope.notifications.splice($scope.notifications.indexOf(notification), 1);
                        $scope.$root.updateScroll('.notifications-drawer .nano');
                        $scope.$root.setNotificationsSeverity();
                    }, 0);
                });
            };

            $scope.showNotificationInfo = function(notification){
                notification.remove = $scope.removeNotification;
                if(notification.hasExtraData && !notification.receivedExtraData){
                    var queryParams = {
                        notificationId: notification.id
                    };
                    store.fetch({
                        path: '/getNotificationModel',
                        queryParams: queryParams,
                        success: function(data){
                            $timeout(function(){
                                notification.loaded = true;
                                if(data){
                                    notification.receivedExtraData = true;
                                    notification[data.type] = data;

                                    if(data.type === "socketUpgradeNotificationInfo"){
                                        notification.socketUpgradeNotificationInfo.releaseNotes =  $sce.trustAsHtml(notification.socketUpgradeNotificationInfo.releaseNotes);
                                    }
                                    $scope.$root.updateScroll('.notifications-drawer .nano');
                                }
                            }, 0);
                        }
                    });
                }
                else {
                    $scope.$root.updateScroll('.notifications-drawer .nano');
                }
            };
        }
   }
}]);